import { Stack, styled } from "@mui/material";

export const MyProfileStackContainer = styled(Stack)(() => ({
    paddingRight: 1.5,
    marginBottom: 6 
}))